import { Injectable } from '@angular/core';

@Injectable()
export class CacheService {

    private cache: any = {};


    setCache(key: string, obj: any) {
        const d = JSON.stringify({ data: obj });
        this.cache[key] = d;
        // window.sessionStorage.setItem(key, d);
    }


    getCache(key: string): any {
        const d = this.cache[key] || '{}'; // window.sessionStorage.getItem(key) || '{}';
        const r = JSON.parse(d);
        return r.data;
    }

}
